import { Weekdays } from '../../enum/cube-schema.enum';

export interface CubeConfigProps {
  token: string;
}

export interface GetUserHeatmapProps {
  params: {
    startDate: string;
    endDate: string;
    appId: string;
    timezone: string;
    segment?: Weekdays;
  };
  config: CubeConfigProps;
}

export interface GetTeamHeatmapProps {
  params: {
    startDate: string;
    endDate: string;
    appId: string;
    teamId: string;
    userIds: string[];
    timezone: string;
    segment?: Weekdays;
  };
  config: CubeConfigProps;
}

export interface IHeatmapRepository {
  getUserHeatmap(props: GetUserHeatmapProps): any;
  getWorkspaceHeatmap(props: GetTeamHeatmapProps): any;
}
